import { createContext, useContext, useState } from "react";

const CompareContext = createContext();

export function CompareProvider({ children }) {
  const [compareList, setCompareList] = useState([]);

  function toggleCompare(provider) {
    setCompareList((prev) => {
      const exists = prev.find((p) => p.npi === provider.npi);
      if (exists) return prev.filter((p) => p.npi !== provider.npi);
      if (prev.length >= 3) return prev;
      return [...prev, {
        npi: provider.npi,
        firstName: provider.firstName,
        lastName: provider.lastName,
        state: provider.state || "",
        totalPayments: provider.totalPayments || provider.totalAmount || 0,
      }];
    });
  }

  function removeCompare(npi) {
    setCompareList((prev) => prev.filter((p) => p.npi !== npi));
  }

  function clearCompare() {
    setCompareList([]);
  }

  function isInCompareList(npi) {
    return compareList.some((p) => p.npi === npi);
  }

  return (
    <CompareContext.Provider value={{ compareList, toggleCompare, removeCompare, clearCompare, isInCompareList }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  return useContext(CompareContext);
}